import { Button, Checkbox, Modal, Typography } from "antd";
import { useState } from "react";

interface AcceptanceConditionModalProps {
  isOpen: boolean;
  onClose: () => void;
  isFirstTime: boolean;
  onAccept: (neverShowAgain: boolean) => void;
}

const AcceptanceConditionModal = ({
  isOpen,
  onClose,
  isFirstTime,
  onAccept,
}: AcceptanceConditionModalProps) => {
  const [neverShowAgain, setNeverShowAgain] = useState(false);

  const handleAccept = () => {
    onAccept(neverShowAgain);
    onClose();
  };

  const checkboxLabel = isFirstTime
    ? "ไม่ต้องแสดงข้อความนี้อีกใน 15 วัน"
    : "ไม่ต้องแสดงข้อความนี้อีกเลย";

  return (
    <Modal
      title={
        <Typography.Title level={4} className="text-center">
          คำสั่งซื้อเรียบร้อย
        </Typography.Title>
      }
      open={isOpen}
      onCancel={onClose}
      footer={[
        <Button
          key="accept"
          type="primary"
          onClick={handleAccept}
          size="large"
          disabled={!neverShowAgain}
          block
        >
          ตกลง
        </Button>,
      ]}
      centered
    >
      <div className="py-4">
        <Typography.Paragraph className="text-xl">
          กรุณา{" "}
          <span className="font-bold text-danger-500 text-2xl">
            อย่าเพิ่งโอน
          </span>{" "}
          รบกวนรอเช็กสต็อกก่อนนะคะ ลูกค้าจะได้รับออเดอร์{" "}
          <span className="font-bold">ถูกต้อง</span> และ{" "}
          <span className="font-bold">รวดเร็ว</span> ค่ะ
        </Typography.Paragraph>
        <div className="mt-4">
          <Checkbox
            checked={neverShowAgain}
            onChange={(e) => setNeverShowAgain(e.target.checked)}
          >
            {checkboxLabel}
          </Checkbox>
        </div>
      </div>
    </Modal>
  );
};

export default AcceptanceConditionModal;
